import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { DatePicker, Select } from "antd";
import dayjs from "dayjs";

import { useDispatch, useSelector } from "react-redux";
import {
  updateRequest,
  fetchDeviceExplorerGraphRequest,
} from "../../../../store/actions/deviceExplorer";
import usDateFormatLast7Days from "../../../../global/utility/usDateFormatLast7Days";

function ViewDeviceExplorerFilter(props) {
  const { id } = props;
  const dispatch = useDispatch();
  const isBLE = useSelector((state) => state.singleDeviceHeader.isBLE);
  const selectedAggregation = useSelector(
    (state) => state.deviceExplorer.selectedAggregation
  );
  const resolution = useSelector((state) => state.deviceExplorer.resolution);


  const endDateTime = useSelector((state) => state.deviceExplorer.endDateTime);
  const startDateTime = useSelector(
    (state) => state.deviceExplorer.startDateTime
  );

  useEffect(() => {
    dispatch(updateRequest({ startDateTime, endDateTime }));
  }, [])

  const handleStartDateChange = (val) => {
    dispatch(
      updateRequest({
        startDateTime: val,
      })
    );
  };
  const handleEndDateChange = (val) => {
    dispatch(
      updateRequest({
        endDateTime: val,
      })
    );
  };
  const handleAggregationChange = (val) => {
    dispatch(
      updateRequest({
        selectedAggregation: val,
      })
    );
  };
  const handleResolutionChange = (val) => {
    dispatch(
      updateRequest({
        resolution: val,
      })
    );
  };
  const handleFilterApply = () => {
    dispatch(
      fetchDeviceExplorerGraphRequest({
        id: id,
        isBLE,
      })
    );
  };

  return (
    <div className="d-flex flex-sm-column flex-md-row justify-content-start align-items-center pt-3 pb-2">
      <div className="d-flex flex-column align-items-start justify-content-start me-2 explorer-date-picker-container ">
        <div className="pb-1">Start date and time</div>
        <DatePicker
          className="explorer-date-picker"
          format="MM-DD-YYYY HH:mm:ss"
          showTime
          allowClear={false}
          onChange={handleStartDateChange}
          //value={dayjs(startDateTime, "YYYY-MM-DD HH:mm:ss")}
          value={dayjs(startDateTime)}
        />
      </div>
      <div className="d-flex flex-column align-items-start justify-content-start me-2 explorer-date-picker-container">
        <div className="pb-1">End date and time</div>
        <DatePicker
          className="explorer-date-picker"
          format="MM-DD-YYYY HH:mm:ss"
          allowClear={false}
          showTime
          //value={dayjs(endDateTime, "YYYY-MM-DD HH:mm:ss")}
          value={dayjs(endDateTime)}
          onChange={handleEndDateChange}
        />
      </div>
      <div className="d-flex flex-column align-items-start justify-content-start me-2 explorer-select-container">
        <div className="pb-1">Aggregation</div>
        <Select
          className="explorer-select"
          value={selectedAggregation}
          onChange={handleAggregationChange}
          options={[
            { value: "first", label: "FIRST" },
            { value: "last", label: "LAST" },
            { value: "count", label: "COUNT" },
            { value: "max", label: "MAX" },
            { value: "min", label: "MIN" },
            { value: "median", label: "MEDIAN" },
            { value: "mean", label: "MEAN" },
            { value: "sum", label: "SUM" },
            { value: "std_dev", label: "STD_DEV" },
          ]}
        />
      </div>
      <div className="d-flex flex-column align-items-start justify-content-start me-2 explorer-select-container">
        <div className="pb-1">Resolution</div>
        <Select
          className="explorer-select"
          value={resolution}
          onChange={handleResolutionChange}
          options={[
            { value: "1 second", label: "1 second" },
            { value: "10 second", label: "10 second" },
            { value: "30 second", label: "30 second" },
            { value: "1 minutes", label: "1 minutes" },
            { value: "5 minutes", label: "5 minutes" },
            { value: "10 minutes", label: "10 minutes" },
            { value: "15 minutes", label: "15 minutes" },
            { value: "30 minutes", label: "30 minutes" },
            { value: "1 hour", label: "1 hour" },
          ]}
        />
      </div>
      <div className="d-flex flex-column align-items-start justify-content-start pt-3">
        <button
          className="font-face-vzw explorer-filter-apply-btn"
          type="button"
          onClick={handleFilterApply}
        >
          Apply
        </button>
      </div>
    </div>
  );
}

ViewDeviceExplorerFilter.propTypes = {
  id: PropTypes.string.isRequired,
};

export default ViewDeviceExplorerFilter;
